var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.hidden
    ? _c(
        "div",
        [
          _vm.hasOneShowingChild(_vm.item.child, _vm.item) &&
          (!_vm.onlyOneChild.child || _vm.onlyOneChild.noShowingChildren) &&
          !_vm.item.alwaysShow
            ? [
                _vm.onlyOneChild
                  ? _c(
                      "app-link",
                      { attrs: { to: _vm.resolvePath(_vm.onlyOneChild.url) } },
                      [
                        _c(
                          "el-menu-item",
                          {
                            class: { "submenu-title-noDropdown": !_vm.isNest },
                            attrs: {
                              index: _vm.resolvePath(_vm.onlyOneChild.url),
                            },
                          },
                          [
                            _c("item", {
                              attrs: {
                                icon:
                                  _vm.onlyOneChild.extra ||
                                  (_vm.item.meta && _vm.item.extra),
                                title: _vm.onlyOneChild.name,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _c(
                "el-submenu",
                {
                  ref: "subMenu",
                  attrs: {
                    index: _vm.item.id
                      ? _vm.item.id.toString()
                      : _vm.resolvePath(_vm.item.url),
                    "popper-append-to-body": "",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _vm.item
                        ? _c("item", {
                            attrs: {
                              icon: _vm.item && _vm.item.extra,
                              title: _vm.item.name,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.item.child, function (childs) {
                    return _c("sidebar-item", {
                      key: childs.id ? childs.id.toString() : childs.url,
                      staticClass: "nest-menu",
                      attrs: {
                        "is-nest": true,
                        item: childs,
                        "base-path": _vm.resolvePath(childs.url),
                      },
                    })
                  }),
                ],
                2
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }